module.exports = __webpack_public_path__ + "img/office-dishes.13d8cc0d.png";